export const days = [
  { value: 7, day: "Sunday" },
  { value: 1, day: "Monday" },
  { value: 2, day: "Tuesday" },
  { value: 3, day: "Wednesday" },
  { value: 4, day: "Thursday" },
  { value: 5, day: "Friday" },
  { value: 6, day: "Saturday" },
];
